export const RISK_SCORE_SETUP_COPY = {
  pageTitle: "Score merge confidence",
  title: "Which checks should SuperPlane run?",
  helper: "When a pull request opens or updates, an agent reviews the change and adds the checks you turn on.",
  scaleHeading: "Risk scale",
  scaleHelper: "A higher score means more risk.",
  categoriesTitle: "Which changes are high risk?",
  categoriesHelper: "Set the lowest score for each kind of change. The pull request score is the highest match.",
  addMore: "Add more",
  addTitle: "Add a category",
  addNameLabel: "Category name",
  addScoreLabel: "Risk",
  addButton: "Add",
  addDuplicate: "This category already exists.",
  addInvalid: "Do not use an equals sign in the name.",
  cancel: "Cancel",
  remove: "Remove",
  save: "Save categories",
  saving: "Saving...",
  scale: [
    { score: 1, label: "Very low", status: "Minimal Risk", tone: "low" },
    { score: 2, label: "Low", status: "Low Risk", tone: "low" },
    { score: 3, label: "Medium", status: "Moderate Risk", tone: "caution" },
    { score: 4, label: "High", status: "High Risk", tone: "critical" },
    { score: 5, label: "Critical", status: "Severe Risk", tone: "critical" },
  ],
  back: "Back to board",
  finish: "Add merge confidence",
  finishing: "Adding...",
  created: "Merge confidence added.",
  missingGitHub: "Connect GitHub in workspace setup before you add merge confidence.",
  previewLabel: "Example task checks",
  previewTaskLabel: "Task",
  previewTaskKey: "SP-184",
  previewEmpty: "Turn on a check to add a score.",
  previewCaption: "Each check you turn on appears on the task.",
  previewScores: {
    risk: { score: "2", status: "Low risk" },
    performance: { score: "5", status: "Follows practices" },
    security: { score: "4", status: "Follows practices" },
    drift: { score: "1", status: "On task" },
    reversibility: { score: "5", status: "Easy to undo" },
  },
} as const;
